// extracted by mini-css-extract-plugin
export default {"frame":"NameEdit_frame__ubEjN","input":"NameEdit_input__eGStl"};